import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  optionsContainer: { height: '200px', overflow: 'auto', gap: '8px' },
  title: {
    width: '80%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));
